var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 427.36 217.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke-width: 4px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #fff200;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 25.57,
    y1: 25.57,
    x2: 401.79,
    y2: 25.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 295.27,
    y1: 99.31,
    x2: 212.5,
    y2: 188.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133.68,
    y1: 99.31,
    x2: 212.5,
    y2: 188.91
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "401.79 48.26 395.66 31.7 379.1 25.57 395.66 19.44 401.79 2.88 407.91 19.44 424.47 25.57 407.91 31.7 401.79 48.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "25.57 48.26 19.44 31.7 2.88 25.57 19.44 19.44 25.57 2.88 31.7 19.44 48.26 25.57 31.7 31.7 25.57 48.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "133.68 122 127.55 105.44 110.99 99.31 127.55 93.19 133.68 76.63 139.81 93.19 156.36 99.31 139.81 105.44 133.68 122"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "295.27 122 289.14 105.44 272.58 99.31 289.14 93.19 295.27 76.63 301.39 93.19 317.95 99.31 301.39 105.44 295.27 122"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "213.72 214.45 207.14 197.07 188.59 197.95 203.08 186.33 196.51 168.96 212.04 179.15 226.54 167.53 221.64 185.45 237.17 195.65 218.61 196.53 213.72 214.45"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeath);
export default __webpack_public_path__ + "static/media/Death.7030c7a95bb82fe8672b6b78dfe7f4c3.svg";
export { ForwardRef as ReactComponent };